import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CSVReader from 'react-csv-reader';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { isAuthenticated, uploadFile, sendLogin } from '../../auth/Auth';
import RegisterButton from '../../components/atoms/RegisterButton';
import { getAccounts } from '../../actions/Accounts';
import { addGochiMenu, addGochiMenuImage } from '../../actions/GochiMenus';
import '../../stylesheets/csv.css';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, addGochiMenu, addGochiMenuImage },
        dispatch
      )
    })
  ),
  withState('listMenu', 'setListMenu', null),
  withState('listImage', 'setListImage', null),
  withState('listSuccess', 'setListSuccess', null),
  withState('listFalse', 'setListFalse', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    listMenu,
    setListMenu,
    listImage,
    setListImage,
    listFalse,
    setListFalse,
    listSuccess,
    setListSuccess
  }) => {
    const listSuc = [];
    const listFal = [];

    const addMenuAction = async (addParam, numin, menuImage) => {
      console.log('NUM IN: ', numin);
      const delay = 1000;
      await new Promise(resolve => setTimeout(resolve, delay * numin));
      const addedMenu = await actions.addGochiMenu(addParam);
      let addImage = [];
      // let num = 0;
      let menuIdCreate = '';
      if (typeof addedMenu.payload.menuId !== 'undefined') {
        console.log('Menu ID Created: ', addedMenu.payload);
        menuIdCreate = addedMenu.payload.menuId;
      }
      console.log('LIST IMAGES: ', listImage);
      if (listImage) {
        console.log('menuImage: ', menuImage);
        Object.keys(listImage).map(async k => {
          console.log('FILE NAME: ', listImage[k].name);
          if (listImage[k].name.split('.')[0] === `${menuImage}`)
            addImage = [listImage[k]];
        });

        console.log('ADD IMAGE: ', addImage);

        const imagePaths = await Promise.all(
          Object.keys(addImage).map(async i => {
            if (
              addImage[i] !== null &&
              typeof addedMenu.payload.menuId !== 'undefined'
            ) {
              const image = addImage[i];
              const imagePath = await uploadFile(
                'menu',
                addedMenu.payload.menuId,
                image,
                'public'
              );
              return imagePath;
            }
            return null;
          })
        );
        const image = imagePaths[0];
        if (image) {
          await actions.addGochiMenuImage(addedMenu.payload.menuId, {
            image
          });
        }
      }

      if (addedMenu.type === 'ADD_GOCHI_MENU_SUCCESS') {
        console.log(
          `menu with name: ${addParam.menuName} ,${`${
            addParam.menuId
          } ,${menuIdCreate}`} success create`
        );
        listSuc.push(`Menu: ${addParam.menuName}, menuId: ${menuIdCreate} \n`);
      } else {
        console.log(`menu with name: ${addParam.menuName}, false create`);
        listFal.push(`Menu: ${addParam.menuName}\n`);
      }
    };

    const registerAction = async () => {
      if (listMenu.length > 0) {
        const arr = [];
        for (let index = 0; index < listMenu.length; index += 1) {
          let menuChildType = '';
          switch (listMenu[index].menuChildType) {
            case '通常':
              menuChildType = 1;
              break;
            case 'こども食堂用(単独)':
              menuChildType = 2;
              break;
            case 'こども食堂用(仮想店舗)グループ':
              menuChildType = 3;
              break;
            case 'グループ共通メニュー':
              menuChildType = 4;
              break;
            default:
              break;
          }

          const tags = listMenu[index].tags
            ? listMenu[index].tags.split(' ').map(el => ({ tagName: el }))
            : [];

          let numberUsePerDay = '';
          if (listMenu[index].numberUsePerDay === 'なし') numberUsePerDay = 0;
          else if (listMenu[index].numberUsePerDay === '1日1枚')
            numberUsePerDay = 1;
          const addParam = {
            menuChildType,
            shopId: listMenu[index].shopId || '',
            groupId: listMenu[index].groupId || '',
            menuName: listMenu[index].menuName || '',
            menuCombo: listMenu[index].menuCombo === '普通' ? 0 : 1,
            price: listMenu[index].menuPrice || '',
            priceCombo: listMenu[index].priceCombo || '',
            quantity: listMenu[index].quantity || '',
            quantityFree: listMenu[index].quantityFree || '',
            quantityFreeDescription:
              listMenu[index].quantityFreeDescription || '',
            numberUsePerDay,
            expiration: listMenu[index].expiration || '',
            expirationEndDate:
              (listMenu[index].expirationEndDate &&
                listMenu[index].expirationEndDate.replaceAll('/', '-')) ||
              '',
            taxType: listMenu[index].taxType || '',
            reducedTaxType: listMenu[index].reducedTaxType || '',
            description: listMenu[index].description || '',
            tags
          };
          if (addParam.shopId || addParam.groupId) {
            arr.push(
              addMenuAction(
                addParam,
                listMenu[index].no || 1,
                listMenu[index].menuImage
              )
            );
          }
        }
        await Promise.all(arr);
      }
    };

    const create = () => {
      registerAction().then(() => {
        console.log('1');
        console.log(listFal);
        setListSuccess(listSuc);
        setListFalse(listFal);
      });
    };

    const handleForce = data => {
      console.log(data);
      setListMenu(data);
    };

    const onChangeFileHandler = event => {
      console.log(event.target.files);
      if (event.target.files.length > 0) {
        const dataImg = {};
        const fileArr = Object.values(event.target.files);
        fileArr.sort(function compare(a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
        for (let m = 0; m < fileArr.length; m += 1) {
          dataImg[m] = fileArr[m];
        }
        setListImage(dataImg);
      }
    };

    const papaparseOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      encoding: 'Shift-JIS'
    };

    return (
      <div className="box-create">
        <h2>Tool Upload CSV data to create Multi-Menus</h2>
        <br />
        <br />
        <CSVReader
          cssClass="csv-reader-input"
          label="Select CSV menu create"
          onFileLoaded={handleForce}
          inputId="csvMenu"
          inputStyle={{ color: 'red' }}
          parserOptions={papaparseOptions}
        />
        {listMenu && (
          <div className="csv-reader-input">
            <p>Select image of menu create</p>
            <input
              className="csv-input"
              type="file"
              name="file"
              accept="image/*"
              multiple
              onChange={onChangeFileHandler}
            />
          </div>
        )}
        {listMenu && (
          <div>
            <br />
            {listSuccess && (
              <ul>
                {listSuccess.map(item => (
                  <li className="text-success">{item}</li>
                ))}
              </ul>
            )}
            {listFalse && (
              <ul>
                {listFalse.map(item => (
                  <li className="text-false">{item}</li>
                ))}
              </ul>
            )}
            <RegisterButton onClickAction={create} />
          </div>
        )}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
